module.exports = __webpack_public_path__ + "img/check-to-slot.c76b50.svg";